module.exports = __webpack_public_path__ + "img/u148.eee015e8.jpg";